import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

export const highlight = (headSlice: string, match: string, trailSlice: string) =>
  `<span style='white-space: pre'>${headSlice}</span><span style="text-decoration: underline; font-size: 1.2em">${match}</span><span style='white-space: pre'>${trailSlice}</span>`;

@Pipe({
  name: 'searchHighlight',
})
export class SearchHighlightPipe implements PipeTransform {
  public constructor(private readonly sanitizer: DomSanitizer) {}

  transform(value: string, searchKey: string): SafeHtml {
    if (!searchKey) {
      return value;
    }

    try {
      const re = new RegExp(`(.*)(${searchKey})(.*)`, 'gi');

      return this.sanitizer.bypassSecurityTrustHtml(
        value?.replace(re, (_, headSlice, match, trailSlice) => highlight(headSlice, match, trailSlice)),
      );
    } catch (error) {
      return value;
    }
  }
}
